import { isEmpty } from 'lodash';
import tmsApi from './../api/tmsApi';
import helper from './helper';

const { getActiveParam, createInputParam } = helper;

export default {
  namespaced: true,
  state: {
    dataState: {
      companies: 'LOADING',
    },
    companies: [],
    timezones: [],
    tenant_customers: [],
    detailData: null,
    detailDataId: null,
    dataLoaded: false,
    count_info: {
      all: 0,
      default: 0,
      transporter: 0,
      customer: 0,
      customer_active: 0,
      customer_inactive: 0,
      manufacturer: 0,
      active: 0,
      inactive: 0,
    },
    query: {
      search: '',
      parent_id: null,
      page: {
        number: 1,
        count: 10,
      },
      sort: {
        by: 'NAME',
        direction: 'ASC',
      },
      type: null,
      active: 'all',
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.companies.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.companies.push(data);
    },
    REPLACE_DATA(state, companies) {
      state.companies.splice(0, state.companies.length, ...companies);
    },
    SET_DATA_TIMEZONES(state, timezones) {
      state.timezones = timezones;
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.parent_id = null;
      query.page.number = 1;
      query.page.count = 10;
      query.sort.by = 'NAME';
      query.sort.direction = 'ASC';
      query.type = null;
      query.active = 'all';
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.search = search;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    SET_QUERY_COUNT(state, count = 10) {
      state.query.page.count = count;
    },
    SET_QUERY_SORT(state, sort) {
      const [by, direction] = sort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_QUERY_TYPE(state, type) {
      state.query.type = type;
    },
    SET_QUERY_PARENT_ID(state, parentId) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.parent_id = parentId;
    },
    SET_QUERY_ACTIVE(state, active) {
      state.query.active = active;
    },
    SET_COUNT_INFO(state, info) {
      state.count_info.all = 0;
      state.count_info.default = 0;
      state.count_info.transporter = 0;
      state.count_info.customer = 0;
      state.count_info.customer_active = 0;
      state.count_info.customer_inactive = 0;
      state.count_info.active = 0;
      state.count_info.inactive = 0;
      state.count_info.manufacturer = 0;
      info.forEach((c) => {
        state.count_info.all += c.count;
        if (c.type === 'DEFAULT') {
          state.count_info.default += c.count;
        } else if (c.type === 'TRANSPORTER') {
          state.count_info.transporter += c.count;
        } else if (c.type === 'CUSTOMER') {
          state.count_info.customer += c.count;
          if (c.active) {
            state.count_info.customer_active += c.count;
          } else {
            state.count_info.customer_inactive += c.count;
          }
        } else if (c.type === 'MANUFACTURER') {
          state.count_info.manufacturer += c.count;
        }
        if (c.active) {
          state.count_info.active += c.count;
        } else {
          state.count_info.inactive += c.count;
        }
      }, this);
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
    DELETE_DETAIL_DATA(state, id) {
      const index = state.companies.findIndex(cmp => cmp.id === id);
      state.companies.splice(index, 1);
    },
    SET_DATA_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
    SET_DATA_COMPANIES({ dataState }, state) {
      dataState.companies = state;
    },
  },
  getters: {
    companies(state) {
      return state.companies;
    },
    timezones(state) {
      return state.timezones;
    },
    userCompany(state, getters, rootState) {
      const userData = rootState.userData || {};
      const company = userData.company || {};

      return company;
    },
    transporters(state, getters) {
      const transporterIds = getters.userCompany._transporterIds || []; // eslint-disable-line

      return state.companies
        .filter(c => transporterIds.indexOf(parseInt(c.id, 10)) > -1);
    },
    customers(state, getters) {
      const customerIds = getters.userCompany._customerIds || []; // eslint-disable-line

      return state.companies
        .filter(c => customerIds.indexOf(parseInt(c.id, 10)) > -1 || c.type === 'CUSTOMER');
    },
    manufacturers(state) {
      return state.companies
        .filter(c => c.type === 'MANUFACTURER');
    },
    tenants(state, getters) {
      const tenantIds = getters.userCompany._tenantIds || []; // eslint-disable-line

      return state.companies
        .filter(c => tenantIds.indexOf(parseInt(c.id, 10)) > -1);
    },
    providers(state, getters) {
      const providerIds = getters.userCompany._providerIds || []; // eslint-disable-line

      return state.companies
        .filter(c => providerIds.indexOf(parseInt(c.id, 10)) > -1);
    },
    tenant_customers(state, getters) {
      const tenantCustomerIds = getters.userCompany._tenantCustomerIds || []; // eslint-disable-line

      return state.companies
        .filter(c => tenantCustomerIds.indexOf(parseInt(c.id, 10)) > -1);
    },
    count_all(state) {
      return state.count_info.all;
    },
    count_default(state) {
      return state.count_info.default;
    },
    count_transporter(state) {
      return state.count_info.transporter;
    },
    count_customer(state) {
      return state.count_info.customer;
    },
    count_customer_active(state) {
      return state.count_info.customer_active;
    },
    count_customer_inactive(state) {
      return state.count_info.customer_inactive;
    },
    count_active(state) {
      return state.count_info.active;
    },
    count_inactive(state) {
      return state.count_info.inactive;
    },
    count_manufacturer(state) {
      return state.count_info.manufacturer;
    },
    query_count(state) {
      return state.query.page.count;
    },
    query_page(state) {
      return state.query.page.number;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    dataStateCompanies(state) {
      return state.dataState.companies;
    },
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const active = getActiveParam(state);
      const type = state.query.type === null
        ? '' : `type: ${state.query.type}`;
      const parentId = createInputParam(state.query, 'parent_id', false);
      let searchQuery = '';
      if (typeof state.query.search === 'string' && state.query.search.trim().length) {
        const q = state.query.search.trim();
        searchQuery = `query: "${q}"`;
      }
      const query = `
        {
          companies(
            offset: ${offset},
            limit: ${limit},
            ${searchQuery}
            ${parentId}
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${type}
            ${active}
          ) {
            id
            type
            name
            namespace
            external_id
            active
            created_at
            metadata
            parent {
              id
            }
          }
        }
      `;
      // commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      commit('SET_DATA_COMPANIES', 'LOADING');
      return api(query, 'companies').then(({ data }) => {
        const { companies } = data;
        commit('REPLACE_DATA', companies);
        commit('SET_DATA_LOADED');
        commit('SET_DATA_COMPANIES', 'LOADED');
      }).catch(() => {
        commit('SET_DATA_COMPANIES', 'ERROR');
      });
    },
    LOAD_INFO({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const parentId = createInputParam(state.query, 'parent_id', false);
      const query = `
        {
          company_info(query: "${state.query.search}" ${parentId}) {
            type
            active
            count
          }
        }
      `;
      // commit('CLEAR_DATA');
      return api(query, 'company_info').then(({ data }) => {
        const { company_info } = data;
        commit('SET_COUNT_INFO', company_info);
      }).catch(() => {
        commit('SET_ERROR', 'LOAD_INFO');
      });
    },
    FIND_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { number, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const offset = (number - 1) * count;
      const limit = count;
      const active = getActiveParam(state);
      const type = state.query.type === null
        ? '' : `type: ${state.query.type}`;
      const query = `
        {
          companies: find_companies(
            query: "${state.query.search}",
            offset: ${offset},
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${type}
            ${active}
          ) {
            id
            type
            name
            namespace
            external_id
            active
            created_at
            metadata
          }
        }
      `;
      commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      return api(query, 'find_companies').then(({ data }) => {
        const { companies } = data;
        companies.forEach((company) => {
          commit('ADD_DATA_ON_LIST', company);
        }, this);
      }).then(() => {
        setTimeout(() => commit('SET_DATA_LOADED'), 1e3);
      }).catch(() => {
        commit('SET_ERROR', 'FIND_DATA');
      });
    },
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          company(id: ${state.detailDataId}) {
            id
            name
            namespace
            external_id
            type
            active
            address {
              country
              state
              city
              address1
              address2
              zip_code
              latitude
              longitude
            }
            partners {
              type
              company {
                id
                name
              }
              expiration_date
            }
            parent {
              id
              name
            }
            subsidiaries {
              id
              name
              type
              active
            }
            metadata
          }
        }
      `;
      return api(query, 'company').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.company);
      }).catch(() => {
        commit('SET_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    UPDATE_DATA({ state, commit, rootState }, payloads) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const {
        metadata,
        name,
        notification_email,
        type,
        address,
        timezone,
      } = payloads;

      const metadataUpdate = metadata || {};
      metadataUpdate.notification_email = notification_email;
      metadataUpdate.timezone = timezone;

      const variables = {
        id: detailDataId,
        input: {
          name,
          type,
          address,
          update_meta: metadataUpdate,
        },
      };

      const query = `
      mutation CompanyUpdate($id: ID!, $input: CompanyUpdate) {
        company: update_company(id: $id, input: $input) {
          id
          name
          type
          address {
            country
            state
            city
            address1
            address2
            zip_code
            latitude
            longitude
          }
          parent {
            id
            name
          }
          subsidiaries {
            id
            name
            type
          }
          metadata
        }
      }`;

      return api({
        query,
        variables,
      }, 'update_company').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.company);
      }).catch(() => {
        commit('SET_ERROR', 'UPDATE_DATA');
      });
    },
    CREATE_DATA({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const name = createInputParam(payloads, 'name');
      const notification_email = createInputParam(payloads, 'notification_email');
      const timezone = createInputParam(payloads, 'timezone');
      const type = createInputParam(payloads, 'type', false);
      const namespace = payloads.namespace
        ? createInputParam(payloads, 'namespace')
        : '';
      const external_id = payloads.external_id
        ? createInputParam(payloads, 'external_id')
        : '';
      let metadata = '';

      const addr = payloads.address;
      let address = '';
      if (!isEmpty(addr)) {
        const country = createInputParam(addr, 'country');
        const addrState = createInputParam(addr, 'state');
        const city = createInputParam(addr, 'city');
        const address1 = createInputParam(addr, 'address1');
        const address2 = createInputParam(addr, 'address2');
        const zipCode = createInputParam(addr, 'zip_code');
        address = `address: {
          ${country}
          ${addrState}
          ${city}
          ${address1}
          ${address2}
          ${zipCode}
        }`;
      }

      if (!isEmpty(notification_email)) {
        metadata = `metadata: {
          ${notification_email}
          ${timezone}
        }`;
      }

      const mutation = `mutation {
        company: create_company(input: {
          ${name}
          ${type}
          ${address}
          ${metadata}
          ${namespace}
          ${external_id}
        }) {
          id
          name
          type
          address {
            country
            state
            city
            address1
            address2
            zip_code
            latitude
            longitude
          }
          parent {
            id
            name
          }
          subsidiaries {
            id
            name
            type
          }
        }
      }`;

      return api(mutation, 'create_company').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.company);
        return data.company;
      }).catch(() => {
        commit('SET_ERROR', 'CREATE_DATA');
      });
    },
    CREATE_SUBSIDIARY({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const name = createInputParam(payloads, 'name');
      const type = createInputParam(payloads, 'type', false);

      const addr = payloads.address;
      let address = '';
      if (!isEmpty(addr)) {
        const country = createInputParam(addr, 'country');
        const addrState = createInputParam(addr, 'state');
        const city = createInputParam(addr, 'city');
        const address1 = createInputParam(addr, 'address1');
        const address2 = createInputParam(addr, 'address2');
        const zipCode = createInputParam(addr, 'zip_code');
        address = `address: {
          ${country}
          ${addrState}
          ${city}
          ${address1}
          ${address2}
          ${zipCode}
        }`;
      }

      const mutation = `mutation {
        company: create_company_subsidiary(parent_id: ${payloads.parent} input: {
          ${name}
          ${type}
          ${address}
        }) {
          id
          name
          type
          address {
            country
            state
            city
            address1
            address2
            zip_code
            latitude
            longitude
          }
          parent {
            id
            name
          }
        }
      }`;

      return api(mutation, 'create_company').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.company);
        return data.company;
      }).catch(() => {
        commit('SET_ERROR', 'CREATE_SUBSIDIARY');
      });
    },
    DELETE_DATA({ state, commit, rootState }, companyId) {
      const id = !companyId ? state.detailDataId : companyId;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        deleted: delete_company(id: ${id})
      }`;

      return api(mutation, 'delete_company').then(({ data }) => {
        const deleteOk = data.deleted;
        if (deleteOk) commit('DELETE_DETAIL_DATA', id);
        return deleteOk;
      }).catch(() => {
        commit('SET_ERROR', 'DELETE_DATA');
      });
    },
    CREATE_PARTNER({ state, rootState, commit }, payloads) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const type = createInputParam(payloads, 'type', false);
      const { company, expiration_date: tempExpDate } = payloads;
      const { id } = company;
      const expirationDate = tempExpDate === ''
        ? tempExpDate
        : createInputParam(payloads, 'expiration_date');

      const mutation = `mutation {
        partner: create_partnership(id: ${detailDataId}, input: {
          partner_id: ${id}
          ${type}
          ${expirationDate}
        }) {
            id
            type
            name
            active
            partners {
              type
              company {
                id
                name
              }
              expiration_date
            }
            parent {
              id
              name
            }
            created_at
          }
      }`;

      return api(mutation, 'create_partner').then(({ data }) => {
        const { partner } = data;
        return partner;
      }).catch(() => {
        commit('SET_ERROR', 'CREATE_PARTNER');
      });
    },
    DELETE_PARTNER({ state, rootState, commit }, partnerId) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        deleted: delete_partnership(id: ${detailDataId}, partner_id: ${partnerId})
      }`;

      return api(mutation, 'delete_partner').then(({ data }) => {
        const deleteOk = data.deleted;
        return deleteOk;
      }).catch(() => {
        commit('SET_ERROR', 'DELETE_PARTNER');
      });
    },
    UPDATE_PARTNER({ state, rootState, commit }, payloads) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const type = createInputParam(payloads, 'type', false);
      const { company, expiration_date: tempExpDate } = payloads;
      const { id } = company;
      const expirationDate = tempExpDate === ''
        ? tempExpDate
        : createInputParam(payloads, 'expiration_date');

      const mutation = `mutation {
        updated: update_partnership(id: ${detailDataId}, input: {
          partner_id: ${id}
          ${type}
          ${expirationDate}
        })
      }`;

      return api(mutation, 'update_partner').then(({ data }) => {
        const { updated } = data;
        return updated;
      }).catch(() => {
        commit('SET_ERROR', 'UPDATE_PARTNER');
      });
    },
    FREE_SEARCH_DATA({ rootState, commit }, querySearch) {
      const api = tmsApi.buildRetry(rootState.token);
      const { value } = querySearch;
      const query = `{
        companies: find_companies(query: "${value}") {
          id
          name
          type
          active
        }
      }`;

      return api(query, 'search_company').catch(() => {
        commit('ADD_ERROR', 'FREE_SEARCH_DATA');
      });
    },
    LOAD_SIMPLE_DATA({ rootState }, payloads) {
      const api = tmsApi.buildRetry(rootState.token);
      const typeData = payloads.tenants === 1 ? 'tenants' : 'companies';
      const query = `
        {
          companies: ${typeData}(
            sort: {
              by: NAME
              direction: ASC
            }
          ) {
            id
            name
            type
          }
        }
      `;
      return api(query, typeData).then(({ data }) => {
        const { companies } = data;
        return companies;
      });
    },
    LOAD_TRANSPORTERS({ rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          companies: load_transporters(
            sort: {
              by: NAME
              direction: ASC
            }
          ) {
            id
            name
            type
          }
        }
      `;
      return api(query, 'transporters').then(({ data }) => {
        const { companies } = data;
        return companies;
      });
    },
    LOAD_TIMEZONES({ rootState, commit }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = '{ timezones }';
      return api(query, 'timezones').then(({ data }) => {
        const { timezones } = data;
        commit('SET_DATA_TIMEZONES', timezones);
        return timezones;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/companies.js